module.exports = "/_next/static/images/d0a05b25c11d1f4c85c19cc9c84d85c5-phone-icon.svg";